import { Box, SolvTheme, Stack } from '@solvhealth/jigsaw-v1';
import React, { ReactNode, useState } from 'react';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import EnterLastNameModal from '~/components/EnterLastName/EnterLastNameModal';
import { SectionNumber } from '~/components/Paperwork/constants';
import PaperworkLayout from '~/components/Paperwork/PaperworkLayout';
import { PGSectionNumber } from '~/components/Paperwork/providerGroups/constants';
import { UserProfile } from '~/core/dapi/models';
import { isProviderGroupLocation } from '~/core/util/location';
import { useSolvSelector } from '~/reducers';
import history from '~/core/history';
import { usePaperworkContextBookingId } from '~/routes/paperwork/PaperworkBookingIdContext';

type StartPaperworkFrameProps = {
  children: ReactNode;
  actions?: ReactNode;
  goToPaperwork: () => void;
  userProfile: UserProfile;
};

const StartPaperworkFrame = ({
  children,
  actions,
  goToPaperwork,
  userProfile,
}: StartPaperworkFrameProps) => {
  const [enterLastNameModalOpen, setEnterLastNameModalOpen] = useState(true);
  const isProviderGroup = useSolvSelector((state) =>
    isProviderGroupLocation(state.location as LocationInterface)
  );

  const bookingId = usePaperworkContextBookingId();

  const goToBooking = () => {
    history.push({ pathname: `/pass/${bookingId}` });
  };

  return (
    <PaperworkLayout
      onGoBack={goToBooking}
      section={isProviderGroup ? PGSectionNumber.Start : SectionNumber.Start}
    >
      <Stack
        justifyContent="center"
        maxWidth={SolvTheme.breakpoints.sm}
        mx="auto"
        px={2}
        space={3}
        textAlign="center"
      >
        <Stack justifyContent="center" space={2} textAlign="center">
          <Box alignSelf="center">
            <img
              alt="Start Paperwork"
              height="128px"
              src="/images/paperwork/startPaperwork.svg"
              width="128px"
            />
          </Box>

          {children}
        </Stack>

        {actions && actions}

        <EnterLastNameModal
          onSkip={() => setEnterLastNameModalOpen(false)}
          onVerifySuccess={goToPaperwork}
          open={enterLastNameModalOpen}
          profileToVerify={userProfile}
        />
      </Stack>
    </PaperworkLayout>
  );
};

export default StartPaperworkFrame;
